/* Cart page interactions. Sweetness/purchase-type/frequency changes swap a
   real cart line (remove + re-add with the right variant/selling plan) via
   the Ajax Cart API, then reload so Shopify recomputes prices/totals
   server-side — simpler and more reliable than hand-rolling a live partial
   re-render, at the cost of a quick reload instead of an instant swap. */
(function () {
  /* A plain remove-then-add (the previous approach) always relocated the
     swapped line, confusing customers about which item they'd just changed.
     Fixed by snapshotting the full current line order, rebuilding that same
     sequence with only the target line's variant/selling-plan swapped, then
     clearing and re-adding every line one at a time — sequential (not
     Promise.all) so the requests reach Shopify in a controlled order;
     parallel requests can arrive out of send-order and undo the whole point
     of this.

     Re-added in REVERSE of the desired final order, not the order itself:
     confirmed directly (adding A, then B, then C in that order left the real
     cart as [C, B, A]) that Shopify prepends each newly-added line to the
     FRONT of the cart rather than appending to the end — the opposite of
     what an earlier version of this fix assumed. Feeding lines in forward
     order therefore reversed the whole cart on every toggle; for an
     odd-length cart that made the middle item look unchanged (its own
     mirror point under reversal) while the ends visibly swapped, which is
     exactly the "the one I changed stayed put but the others jumped" bug
     this was reported as. */
  function swapLine(oldKey, newVariantId, qty, sellingPlanId) {
    document.body.classList.add('is-loading');
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items.map(function (item) {
          if (item.key === oldKey) {
            return { id: newVariantId, quantity: qty, sellingPlan: sellingPlanId || null };
          }
          return {
            id: item.variant_id,
            quantity: item.quantity,
            sellingPlan: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null,
          };
        });
        return fetch('/cart/clear.js', { method: 'POST' }).then(function () {
          return lines.slice().reverse().reduce(function (chain, line) {
            return chain.then(function () {
              return window.ChaiCart.add(line.id, line.quantity, line.sellingPlan);
            });
          }, Promise.resolve());
        });
      })
      .then(function () { location.reload(); })
      .catch(function () { location.reload(); });
  }

  document.addEventListener('change', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;

    if (e.target.matches('[data-cart-qty-input]')) {
      var typedQty = parseInt(e.target.value, 10);
      if (isNaN(typedQty) || typedQty < 1) typedQty = 1;
      if (typedQty > 20) typedQty = 20;
      e.target.value = typedQty;
      window.ChaiCart.changeLine(key, typedQty).then(function () { location.reload(); });
      return;
    }

    if (e.target.matches('[data-cart-sweetness]')) {
      swapLine(key, e.target.getAttribute('data-variant-id'), qty, null);
      return;
    }

    if (e.target.matches('[data-cart-purchase]')) {
      var mode = e.target.getAttribute('data-cart-purchase');
      var freqSelect = line.querySelector('[data-cart-frequency]');
      if (mode === 'subscribe') {
        var planId = e.target.getAttribute('data-default-plan-id');
        var currentVariantId = line.querySelector('[data-cart-sweetness]:checked')
          ? line.querySelector('[data-cart-sweetness]:checked').getAttribute('data-variant-id')
          : null;
        if (currentVariantId) swapLine(key, currentVariantId, qty, planId);
        return;
      } else {
        var sweetInput = line.querySelector('[data-cart-sweetness]:checked');
        var vId = sweetInput ? sweetInput.getAttribute('data-variant-id') : null;
        swapLine(key, vId, qty, null);
        return;
      }
    }

    if (e.target.matches('[data-cart-frequency]')) {
      var sweetChecked = line.querySelector('[data-cart-sweetness]:checked');
      var variantId = sweetChecked ? sweetChecked.getAttribute('data-variant-id') : null;
      swapLine(key, variantId, qty, e.target.value);
      return;
    }
  });

  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;

    if (e.target.closest('[data-cart-qty-inc]')) {
      window.ChaiCart.changeLine(key, Math.min(20, qty + 1)).then(function () { location.reload(); });
    } else if (e.target.closest('[data-cart-qty-dec]')) {
      window.ChaiCart.changeLine(key, Math.max(1, qty - 1)).then(function () { location.reload(); });
    } else if (e.target.closest('[data-cart-remove]')) {
      window.ChaiCart.changeLine(key, 0).then(function () { location.reload(); });
    }
  });

  /* "Add these too" cross-sell cards deliberately use their own
     [data-cross-sell-add] attribute rather than the sitewide [data-add-to-cart]
     one product-card.js already handles — that shared handler doesn't reload
     after adding, but every other mutation on this page does (see swapLine
     above), so a cross-sell add needs its own reload-after-success handler to
     keep the line list, subtotal, and shipping bar above it from going stale. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cross-sell-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';
    window.ChaiCart.add(variantId, 1)
      .then(function () { location.reload(); })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });

  var countrySelect = document.getElementById('cart-country');
  var canadaNote = document.getElementById('CartCanadaNote');
  if (countrySelect && canadaNote) {
    var subtotalCents = parseInt(canadaNote.getAttribute('data-subtotal-cents'), 10) || 0;
    var estimate = (subtotalCents / 100 * 0.35).toFixed(2);
    var estimateEl = document.getElementById('CartTariffEstimate');
    if (estimateEl) estimateEl.textContent = '~$' + estimate;
    countrySelect.addEventListener('change', function () {
      canadaNote.style.display = countrySelect.value === 'CA' ? 'grid' : 'none';
    });
  }
})();
